import script from "./phone-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./phone-input.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./phone-input.vue?vue&type=style&index=0&id=4fc722d6&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__